export default __webpack_public_path__ + "static/media/group2.6f765504.png";